import { useTranslation } from 'react-i18next';
import CategoryDropdown from './CategoryDropdown';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=Soft%20airy%20abstract%20background%20with%20gently%20floating%20fashion%20product%20silhouettes%20of%20sneakers%20hoodies%20and%20bags%20in%20warm%20cream%20sage%20green%20and%20soft%20coral%20tones%2C%20minimal%20editorial%20style%2C%20lots%20of%20negative%20space%2C%20gentle%20gradient%2C%20high%20detail%2C%20calm%20and%20fresh%20aesthetic&width=1600&height=900&seq=hero-usfans-2026&orientation=landscape';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-background-50">
      <div className="absolute inset-0">
        <img src={HERO_IMAGE} alt="" aria-hidden="true" className="h-full w-full object-cover object-top opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50"></div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100/80 px-4 py-1.5 text-xs font-semibold text-primary-700">
            <i className="ri-sparkling-2-line" aria-hidden="true"></i>
            {t('hero_badge')}
          </span>
          <h1 className="mt-5 text-3xl md:text-5xl font-bold leading-tight text-foreground-950">
            {t('hero_title')}
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-base md:text-lg leading-relaxed text-foreground-600">
            {t('hero_subtitle')}
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 whitespace-nowrap transition-colors"
            >
              {t('btn_spreadsheet')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto rounded-full bg-accent-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-accent-600 whitespace-nowrap transition-colors"
            >
              {t('btn_buy_now')}
            </a>
          </div>

          <div className="mt-10 flex justify-center">
            <CategoryDropdown />
          </div>
        </div>
      </div>
    </section>
  );
}